import { MANAGE_LOCK_TABS } from "@/domains/lock-page/constants"

import { ComplexBreadcrumbItem } from "../../types/complex-breadcrumb-item"
import { ComplexBreadcrumbDropdown } from "../complex-breadcrumb-dropdown"

export const LockPagesComplexBreadcrumbApplication: ComplexBreadcrumbItem = {
  type: "complex",
  application: "lock-pages",
  render: () => <LockPagesComplexBreadcrumbApplicationComponent />,
}

export const LockPagesComplexBreadcrumbApplicationComponent = () => {
  return (
    <ComplexBreadcrumbDropdown tabs={MANAGE_LOCK_TABS} navigationMode="slug" invalidTabMessage="Invalid lock tab" />
  )
}
